import { render, staticRenderFns } from "./WidgetSettingsTab.vue?vue&type=template&id=229d8cc2"
import script from "./WidgetSettingsTab.vue?vue&type=script&lang=js"
export * from "./WidgetSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./WidgetSettingsTab.vue?vue&type=style&index=0&id=229d8cc2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('229d8cc2')) {
      api.createRecord('229d8cc2', component.options)
    } else {
      api.reload('229d8cc2', component.options)
    }
    module.hot.accept("./WidgetSettingsTab.vue?vue&type=template&id=229d8cc2", function () {
      api.rerender('229d8cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/components/Settings/WidgetSettingsTab.vue"
export default component.exports